import React, { Fragment, FunctionComponent } from 'react';
import { WPAcfGlobalOfferPage } from 'types/acf';
import { WPSimplePage } from 'types/pages';
import { Benefits, Gallery, Growth, Initiatives, Process } from 'components/containers';

interface OwnProps {
  data: WPSimplePage<WPAcfGlobalOfferPage>;
}

type OfferGlobalProps = JSX.IntrinsicElements['div'] & OwnProps;

const OfferGlobal: FunctionComponent<OfferGlobalProps> = props => {
  const { data: offer } = props;
  const {
    acf: { growth, benefits, process, companyInitiatives, gallery },
  } = offer || {};

  return (
    <Fragment>
      <Growth data={growth} />
      <Benefits data={benefits} />
      <Process data={process} />
      <Initiatives data={companyInitiatives} />
      <Gallery data={gallery} />
    </Fragment>
  );
};

export default OfferGlobal;
